import { fn } from '@ember/helper';
import { action } from '@ember/object';
import Component from '@glimmer/component';
import { PrismButton } from '@mylighthouse/prism-ember';
import EmberPopover from '@mylighthouse/prism-ember/components/ember-popover';
import { t } from 'ember-intl';
import { Illustration } from 'frontend-utils';
import HowToReadChartIllustration from 'lumen/assets/images/total-revenue/how-to-read-chart.svg?raw';

interface MarketTotalRevenueStrategyChartSegmentPopoverHowToReadSignature {
  Args: {};
}

export default class MarketTotalRevenueStrategyChartSegmentPopoverHowToRead extends Component<MarketTotalRevenueStrategyChartSegmentPopoverHowToReadSignature> {
  @action
  closePopover(popover: unknown): void {
    (popover as { hide: () => void }).hide();
  }

  <template>
    <EmberPopover
      @arrowClass="popover-how-to-read__arrow"
      @event="click"
      @side="right"
      @tooltipClass="popover-how-to-read"
      as |popover|
    >
      <div class="flex flex-col gap-500">
        <div class="flex items-center justify-between gap-200">
          <h4>{{t "total_revenue.how_to_read_this_chart"}}</h4>

          <PrismButton
            @buttonType="ghost"
            @icon="cross"
            @onClick={{fn this.closePopover popover}}
          />
        </div>

        <Illustration
          @html={{HowToReadChartIllustration}}
          aria-label={{t "total_revenue.how_to_read_this_chart"}}
          class="popover-how-to-read__illustration"
        />

        <div class="popover-how-to-read__classifications">
          <span class="text-200--bold text-nowrap">
            {{t "total_revenue.strategy.explanation.upsell.title"}}
          </span>
          <span class="paragraph-200--regular">
            {{t "total_revenue.strategy.explanation.upsell.description"}}
          </span>

          <span class="text-200--bold text-nowrap">
            {{t "total_revenue.strategy.explanation.nurture.title"}}
          </span>
          <span class="paragraph-200--regular">
            {{t "total_revenue.strategy.explanation.nurture.description"}}
          </span>

          <span class="text-200--bold text-nowrap">
            {{t "total_revenue.strategy.explanation.market.title"}}
          </span>
          <span class="paragraph-200--regular">
            {{t "total_revenue.strategy.explanation.market.description"}}
          </span>

          <span class="text-200--bold text-nowrap">
            {{t "total_revenue.strategy.explanation.reconsider.title"}}
          </span>
          <span class="paragraph-200--regular">
            {{t "total_revenue.strategy.explanation.reconsider.description"}}
          </span>
        </div>
      </div>
    </EmberPopover>
  </template>
}
